import { Injectable } from '@angular/core';

import { FsImpersonate } from '@firestitch/impersonate';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { addHours } from 'date-fns';

import { OneTimePasswordData } from '../data';


@Injectable({
  providedIn: 'root',
})
export class ImpersonateService {

  constructor(
    private _impersonate: FsImpersonate,
    private _oneTimePasswordData: OneTimePasswordData,
  ) { }

  public impersonate(account): Observable<string> {
    return this._impersonate.impersonate({
      email: account.email,
      code: this._oneTimePasswordData.post({
        accountId: account.id,
        expiryDate: addHours(new Date(), 1),
      })
        .pipe(
          map((oneTimePassword) => oneTimePassword.password),
        ),
    });
  }

}
